'use client';

import { Loader2 } from 'lucide-react';
import { cn } from '@/lib/utils';

export function MetricsLoadingOverlay({
  loading,
  children,
}: {
  loading: boolean;
  children: React.ReactNode;
}) {
  return (
    <div className="relative" aria-busy={loading}>
      <div className={cn(
        'transition-opacity duration-150',
        loading && 'pointer-events-none opacity-50',
      )}>
        {children}
      </div>
      {loading && (
        <div
          role="status"
          aria-label="Loading metrics"
          className="pointer-events-none absolute inset-0 z-30 flex items-center justify-center"
        >
          <span className="rounded-full border bg-background/90 p-2 shadow-sm">
            <Loader2 className="h-5 w-5 animate-spin text-primary" />
          </span>
        </div>
      )}
    </div>
  );
}
